
import card from '~/mixins/card'
import visibilityTracker from '~/mixins/visibility-tracker'

export default {
    mixins: [card, visibilityTracker]
}
